// Generischer Mini-Job-Tracker fuer atomare async Operationen, fuer
// die kein WS-Action-Frame-Backend existiert (z.B. zfs clone -- in
// einer Sekunde durch). Jeder Aufruf legt einen Eintrag an, ein
// spaeteres setDone/setFailed schliesst den Job. Pille verschwindet
// nach kurzer Halte-Zeit von selbst.
//
// Sichtbar gemacht ueber JobToastsPanel.svelte, das in App.svelte
// global eingehaengt ist.

import { SvelteMap } from "svelte/reactivity";

export type JobPhase = "running" | "done" | "failed";

export interface JobToast {
  id: string;
  label: string;
  phase: JobPhase;
  message?: string;
  startedAt: number;
}

const _jobs = new SvelteMap<string, JobToast>();

const HOLD_DONE_MS = 4_000;
const HOLD_FAILED_MS = 12_000;

export function jobs(): SvelteMap<string, JobToast> {
  return _jobs;
}

export function startJob(id: string, label: string): void {
  _jobs.set(id, {
    id,
    label,
    phase: "running",
    startedAt: Date.now(),
  });
}

export function setJobDone(id: string, message?: string): void {
  const j = _jobs.get(id);
  if (!j) return;
  _jobs.set(id, { ...j, phase: "done", message });
  setTimeout(() => _jobs.delete(id), HOLD_DONE_MS);
}

export function setJobFailed(id: string, reason: string): void {
  const j = _jobs.get(id);
  if (!j) {
    // Falls startJob aus irgendeinem Grund verschluckt wurde,
    // legen wir den Fehler trotzdem an damit der User ihn sieht.
    _jobs.set(id, {
      id,
      label: id,
      phase: "failed",
      message: reason,
      startedAt: Date.now(),
    });
  } else {
    _jobs.set(id, { ...j, phase: "failed", message: reason });
  }
  setTimeout(() => _jobs.delete(id), HOLD_FAILED_MS);
}
